const publicUrl = process.env.PUBLIC_URL ?? '';

/**
 * Kategori kart görselleri — public/images/categories/ altında statik dosyalar.
 * Yeni görsel eklemek için ilgili hub/slug.png dosyasını değiştirmeniz yeterli.
 */
const categoryImages = {
  davetiyeler: {
    dugun: `${publicUrl}/images/categories/davetiyeler/dugun.png`,
    dugunekonomik: `${publicUrl}/images/categories/davetiyeler/dugunekonomik.jpg`,
    nisan: `${publicUrl}/images/categories/davetiyeler/nisan.png`,
    sunnet: `${publicUrl}/images/categories/davetiyeler/sunnet.png`,
  },
  sekerlik: {
    dugun: `${publicUrl}/images/categories/sekerlik/dugun.png`,
    nisan: `${publicUrl}/images/categories/sekerlik/nisan.png`,
    sunnet: `${publicUrl}/images/categories/sekerlik/sunnet.png`,
    dogum: `${publicUrl}/images/categories/sekerlik/dogum.png`,
  },
};

export function getCategoryImage(hub, slug) {
  return categoryImages[hub]?.[slug] ?? null;
}
